import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { translations } from 'i18n';
import ToggleList from 'components/Toggle/ToggleList';

export default class PermissionList extends Component {
  static propTypes = {
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
      .isRequired,
    newPermissions: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    permissionAlerts: PropTypes.object,
    permissions: PropTypes.object.isRequired,
    visiblePermissions: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  static defaultProps = {
    newPermissions: [],
    permissionAlerts: {}
  };

  onChange = async (...args) => this.props.onChange(...args);

  renderItem = (itemProps) => {
    const { itemComponent: ItemComponent } = this.props;

    return <ItemComponent {...itemProps} />;
  };

  render() {
    const {
      containerComponent,
      newPermissions,
      visiblePermissions,
      permissions,
      permissionAlerts
    } = this.props;
    const {
      comms: { permissions: permissionsText }
    } = translations;

    const items = visiblePermissions.map((permission) => ({
      description: permissionsText[permission].description(),
      isNew: newPermissions.includes(permission),
      showWarning: !!permissionAlerts[permission],
      title: permissionsText[permission].label(),
      value: permission
    }));

    return (
      <ToggleList
        containerComponent={containerComponent}
        items={items}
        onChange={this.onChange}
        renderItem={this.renderItem}
        valueToggles={permissions}
      />
    );
  }
}
